import { render, staticRenderFns } from "./birthdays-tomorrow.vue?vue&type=template&id=5e5a4550&scoped=true"
import script from "./birthdays-tomorrow.vue?vue&type=script&lang=js"
export * from "./birthdays-tomorrow.vue?vue&type=script&lang=js"
import style0 from "./birthdays-tomorrow.vue?vue&type=style&index=0&id=5e5a4550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a4550",
  null
  
)

export default component.exports